import { mergeAttributes, Node, type JSONContent } from '@tiptap/core'

import type { EmptyObject } from '~shared/core/primitives'
import { NodeAttributes } from '~shared/richtext/richtext.types'
export const FILENODE_NAME = 'rsFileNode' as const
export const FILENODE_TAG = 'rs-file' as const

/** @deprecated We're migrating from `<file-component/>` to `<rs-file/>` */
export const FILENODE_TAG_LEGACY = 'file-component' as const

type FileNodeOptions = EmptyObject

export type FileNodeAttributes = {
  filename: string
  size: string
  type: string
  url: string
}

export const FileNode = Node.create<FileNodeOptions, FileNodeAttributes>({
  name: FILENODE_NAME,
  group: 'block',
  atom: true,
  draggable: false,

  addAttributes() {
    return {
      filename: { default: '' },
      size: { default: '' },
      type: { default: '' },
      url: { default: '' },
    } satisfies NodeAttributes<FileNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: FILENODE_TAG },
      { tag: FILENODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      FILENODE_TAG,
      mergeAttributes(HTMLAttributes),
      '', // Add empty child to force a closing tag
    ]
  },

  renderText({ node }) {
    const attrs = node.attrs as FileNodeAttributes

    const filename = attrs.filename ?? 'file'
    const url = attrs.url ?? ''

    return `${filename} [${url}]`
  },
})

/** Strictly typed Tiptap JSON content block */
export interface FileNodeBlock extends JSONContent {
  type: typeof FILENODE_NAME
  attrs: FileNodeAttributes
}

/** Create a (compile-time) type-safe Tiptap JSON content block */
export function createFileBlock(attrs: FileNodeAttributes): FileNodeBlock {
  return {
    type: FILENODE_NAME,
    attrs: attrs,
  }
}
